export default "__VITE_ASSET__CTIV8U$G__"